import React, { useEffect, useState } from "react";
import { Footer } from "../Footer";
import { Background } from "../home/Background";
import analytics from "../services/analytics";
import { Navigation } from "../navigation/Navigation";
import styled from "styled-components";
import { UserLookupResult } from "../services/userLookupService";
import { AccountDetailsStepView } from "./steps/AccountDetailsStepView";
import { DeletingAccountStepView } from "./steps/DeletingAccountStepView";
import { SignInStepView } from "./steps/SignInStepView";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-width: 300px;
  min-width: 250px;
  height: 250px;
  margin: 20px auto;
`;

const DeleteAccountPage: React.FC = () => {
  useEffect(() => {
    analytics.logPageView("deleteAccount");
  }, []);

  const buildSignInStepView = () => (
    <SignInStepView
      onAuthenticated={(userLookupResult) => {
        setStepView(
          buildAccountDetailsView({
            userLookupResult,
          }),
        );
      }}
    />
  );

  const buildAccountDetailsView = (args: {
    readonly userLookupResult: UserLookupResult;
  }) => (
    <AccountDetailsStepView
      userLookupResult={args.userLookupResult}
      onDeleteAccount={(foundUserLookupResult) => {
        setStepView(
          <DeletingAccountStepView
            foundUserLookupResult={foundUserLookupResult}
          />,
        );
      }}
      onGoBack={() => {
        setStepView(buildSignInStepView());
      }}
    />
  );

  const [stepView, setStepView] = useState(buildSignInStepView());

  return (
    <Background>
      <Navigation />
      <Container>{stepView}</Container>
      <Footer />
    </Background>
  );
};

export default DeleteAccountPage;
